import type { AboutCopy } from '../types/about';

export const aboutRo: AboutCopy = {
  seo: {
    title: 'Despre noi',
    description:
      'SafestMenu este construit și operat de transfactor.dev, o echipă senior de dezvoltare software din București, România - certificată ISO 9001 și ISO/IEC 27001.',
  },
  hero: {
    eyebrow: 'Despre noi',
    heading:
      'Făcut de oameni care construiesc software ca meserie - și ies des la restaurant.',
  },
  story: {
    intro:
      'SafestMenu a pornit de la o observație simplă: meniurile pe hârtie sunt scumpe de retipărit, imposibil de ținut la zi, trec prin mâinile a sute de clienți și ajung la gunoi cu teancul. Fiecare restaurant cu care am vorbit avea aceeași problemă - și niciun timp pentru o soluție complicată.',
    easyIntro:
      'Așa că am construit meniul pe care ni l-am dori în propriul restaurant: unul pe care îl configurezi în câteva minute, îl actualizezi de pe telefon și nu-l mai tipărești niciodată. ',
    easyHighlight: 'Ușor de folosit',
    easyOutro: ' nu a fost o funcție pe o listă - a fost chiar scopul.',
    imageAlt: 'Un cartonaș cu cod QR SafestMenu pe o masă de cafenea, lângă un espresso',
  },
  team: {
    heading: 'Echipa din spatele proiectului',
    linkIntro: 'SafestMenu este construit și operat de ',
    linkText: 'transfactor.dev',
    linkOutro:
      ', o echipă senior de dezvoltare software cu sediul în București, România. transfactor.dev proiectează, construiește și livrează produse web, sisteme AI și instrumente interne - peste douăzeci de produse livrate și optsprezece ani de experiență cumulată, cu certificare ISO 9001 și ISO/IEC 27001.',
    reliability:
      'Asta contează pentru tine într-un mod concret: SafestMenu nu este un proiect secundar care dispare anul viitor. Este întreținut, securizat și îmbunătățit de aceeași echipă, în fiecare săptămână.',
  },
  beliefs: {
    heading: 'În ce credem',
    items: [
      'Software-ul pentru restaurante ar trebui să fie mai simplu decât condusul unui restaurant.',
      'Clienții merită meniuri oneste: prețuri clare, fotografii reale, alergeni marcați.',
      'Mai puțină hârtie la gunoi e bine pentru toată lumea - inclusiv pentru bugetul tău.',
    ],
  },
  cta: {
    label: 'Încearcă SafestMenu gratuit',
  },
};
